import AddApiAccessKey from "./AddApiAccessKey.js"; // import ApiDocumentationDownload from './ApiDocumentationDownload';
// import ApiDocumentationLink from './ApiDocumentationLink';
import ColumnEditApiAccessKey from "./ColumnEditApiAccessKey.js";
import EditApiAccessKey from "./EditApiAccessKey.js";
import RemoveApiAccessKey from "./RemoveApiAccessKey.js";
import ToggleApiAccessKey from "./ToggleApiAccessKey.js";
import ViewAssociatedIds from "./ViewAssociatedIds.js";
import AddUser from "./AddUser.js";
import RemoveUsers from "./RemoveUsers.js";
import ColumnEditUser from "./ColumnEditUser.js";
import Create from "../temporaryUser/actions/Create.js";
import Delete from "../temporaryUser/actions/Delete.js";
import Revoke from "../temporaryUser/actions/Revoke.js";
import Renew from "../temporaryUser/actions/Renew.js"; // import TargetMenu from './TargetMenu';
export default {
  install(plg) {
    // Api Access
    plg.addPlugin('Action', AddApiAccessKey);
    // plg.addPlugin( 'Action', ApiDocumentationDownload )
    // plg.addPlugin( 'Action', ApiDocumentationLink )
    plg.addPlugin('Action', ColumnEditApiAccessKey);
    plg.addPlugin('Action', EditApiAccessKey);
    plg.addPlugin('Action', RemoveApiAccessKey);
    plg.addPlugin('Action', ToggleApiAccessKey);
    plg.addPlugin('Action', ViewAssociatedIds);

    // User
    plg.addPlugin('Action', AddUser);
    plg.addPlugin('Action', RemoveUsers);
    plg.addPlugin('Action', ColumnEditUser);
    // plg.addPlugin( 'Action', TargetMenu )
    plg.addPlugin('Action', Create);
    plg.addPlugin('Action', Delete);
    plg.addPlugin('Action', Revoke);
    plg.addPlugin('Action', Renew);
  }
};